import { render, staticRenderFns } from "./referral-code-setting-form.vue?vue&type=template&id=ac819b1e"
import script from "./referral-code-setting-form.vue?vue&type=script&lang=js"
export * from "./referral-code-setting-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports